import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
export function destroy() {
  r.D.info("Destroying Braze instance"), e.destroy(!0);
}
